<template>
  <div class="tw:h-full tw:flex tw:items-center">
    <Input
      v-if="isRenaming"
      ref="inputRef"
      v-model="titleValue"
      class="tw:w-full tw:h-8 tw:text-sm"
      @keyup.enter.stop="confirmTitleValue"
      @keydown.esc.stop=""
      @keyup.esc.stop="toggleIsRenaming(false)"
      @click.stop=""
    />

    <CustomTooltip
      v-else
      :text="teamAsset.title"
    >
      <h5
        ref="titleRef"
        class="tw:mb-0 tw:text-center tw:text-xs tw:font-bold tw:truncate tw:w-full"
        @click.stop="toggleIsRenaming(true)"
      >
        {{ teamAsset.title }}
      </h5>
    </CustomTooltip>
  </div>
</template>

<script>
import { nextTick, ref, useTemplateRef, watch } from 'vue'
import CustomTooltip from '@/components/custom-tooltip.vue'
import { Input } from '@/shadcn/components/ui/input/index.js'
import { useTeamAssetItem } from './use-team-asset-item'
import { useTeamAssets } from './use-team-assets'

export default {
  name: 'TeamAssetItemTitle',
  components: { CustomTooltip, Input },
  setup() {
    const inputRef = useTemplateRef('inputRef')
    const titleValue = ref('')

    const { updateTeamAsset } = useTeamAssets()
    const { teamAsset, isRenaming, toggleIsRenaming } = useTeamAssetItem()

    watch(isRenaming, (value) => {
      if (value) {
        titleValue.value = teamAsset.value.title
        nextTick(() => {
          inputRef.value.inputRef.focus()
          inputRef.value.inputRef.select()
        })
      }
    })

    const confirmTitleValue = async () => {
      await updateTeamAsset(teamAsset.value, { title: titleValue.value })

      toggleIsRenaming(false)
    }

    return {
      teamAsset,

      titleValue,

      isRenaming,
      toggleIsRenaming,

      confirmTitleValue,
    }
  },
}
</script>
